import { api } from "..";

interface ResetMainDealerStepUpPasswordPayload {
  dealerId: number;
}

export async function resetMainDealerStepUpPassword(
  payload: ResetMainDealerStepUpPasswordPayload
): Promise<{ success: boolean }> {
  const res = await api.client.post(
    `/dealers-new/${payload.dealerId}/reset-step-up-password`
  );
  return res.data;
}
